module.exports = __webpack_public_path__ + "img/us_未标题-4.78ac6cfb.jpg";